// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    priceGroupList: [],
    selectedPriceGroup: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'priceGroup',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setPriceGroups(state, action) {
            state.priceGroupList = action.payload;
        },
        setSelectedPriceGroup(state, action) {
            state.selectedPriceGroup = action.payload;
        },
        setPriceGroup(state, action) {
            const data = action.payload;
            const rowIndex = state.priceGroupList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.priceGroupList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedPriceGroup } = slice.actions;
// ----------------------------------------------------------------------

export function getPriceGroups() {
    return async () => {
        try {
            const response = await axios.post('/price_group/list');
            if (response.data.status) {
                dispatch(slice.actions.setPriceGroups(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
export function getPriceGroup(id) {
    return async () => {
        try {
            const response = await axios.post('/price_group/details', { id });
            if (response.data.status) {
                dispatch(slice.actions.setPriceGroup(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            console.log(error);
        }
    };
}
export function savePriceGroup(data) {
    return async function () {
        const response = await axios.post('price_group/save', data);
        return response;
    };
}

export function updatePriceGroup(data) {
    return async function () {
        const response = await axios.post('price_group/update', data);
        return response;
    };
}

export function deletePriceGroup(data) {
    return async function () {
        const response = await axios.post('price_group/delete', data);
        return response;
    };
}
